/* oxlint-disable react-doctor/rendering-hydration-mismatch-time */
import MoneyDisplay from 'components/util/MoneyDisplay';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ClassifierData } from 'types/classifiers';
import { ExpenseFormData, ExpenseStatusType } from 'types/expenses';
import { cn } from 'utils/cn';
import { formatDateStringInput } from 'utils/formatDateStringInput';
import { getClassifierText } from 'utils/getTranslations';
import { TimecardStatusLabel } from '../labels/TimecardStatusLabel';

type Props = {
    expense: ExpenseFormData;
    handleEdit: () => void;
    disableView?: boolean;
    classifiers: Record<string, ClassifierData>;
    readOnly: boolean;
};

const ExpenseItem: React.FC<Props> = ({ expense, handleEdit, disableView = false, classifiers, readOnly = false }) => {
    const textId =
        readOnly || (!!expense.expenseStatusTypeCode && expense.expenseStatusTypeCode !== ExpenseStatusType.FINISHED)
            ? 'expenses.view-expense'
            : 'expenses.edit';

    const expenseAmount =
        (expense.isEdited || expense.isCreated
            ? Number(expense.expenseAmountOriginalCurrency)
            : Number(expense.expenseAmount)) || 0;
    const expenseCurrency =
        expense.isEdited || expense.isCreated ? expense.originalCurrencyTypeCode : expense.currencyTypeCode;

    return (
        <div className="bg-paper text-fg border-divider new:border-0 new:shadow-card new:outline-hidden w-full overflow-hidden rounded-[7px] border p-4">
            <div
                className={cn(
                    'grid gap-2 pb-2',
                    expense.expenseStatusTypeCode ? 'grid-cols-[auto_auto_auto_1fr]' : 'grid-cols-[auto_auto_1fr]'
                )}
            >
                <div className="font-semibold whitespace-nowrap">
                    {formatDateStringInput(new Date(expense.expenseDate))}
                </div>
                {expense.expenseStatusTypeCode && (
                    <TimecardStatusLabel
                        classifier={classifiers['EXPENSE_STATUS_TYPE']}
                        statusCode={expense.expenseStatusTypeCode}
                    />
                )}
                <div className="text-fg-secondary">{expense?.employee ? `${expense.employee.name}` : ''}</div>
                <div className="justify-self-end">
                    <MoneyDisplay amount={expenseAmount} currency={expenseCurrency} />
                </div>
            </div>
            <div className="flex flex-col gap-1">
                <React.Fragment>
                    {getClassifierText(classifiers['EXPENSE_TYPE'], expense.expenseTypeCode)}
                    {expense.description ? `,\u00A0` : ''}
                    {expense.description}
                </React.Fragment>
                {!disableView ? (
                    <button
                        type="button"
                        className="text-link w-fit cursor-pointer text-left no-underline hover:underline"
                        onClick={handleEdit}
                    >
                        <FormattedMessage id={textId} />
                    </button>
                ) : null}
            </div>
        </div>
    );
};

export default ExpenseItem;
